export default {
  toasts: {
    printing: 'Imprimiendo...',
    print_failed: 'Error al imprimir. Por favor, inténtalo de nuevo',
    orders: {
      print_one: 'Imprimiendo {{count}} recibo: Pedido <strong>#{{orderNumber}}</strong>...',
      print_other: 'Imprimiendo {{count}} recibos: Pedido <strong>#{{orderNumber}}</strong>...',
    },
  },
};
